import { useCallback } from "react";

import { useUndoTurnConfirmation } from "#/components/game/useUndoTurnConfirmation";
import { useGameSelector, useGameStoreApi } from "#/game/GameStoreProvider";
import {
  canUndoCommittedTurnFromState,
  canUndoPendingMovesFromState,
} from "#/game/store/selectors";

export function usePlayMapUndo({
  onUndoCommittedTurn,
  pending,
  allowUndoFullTurn = true,
}: {
  onUndoCommittedTurn: () => void;
  pending: boolean;
  allowUndoFullTurn?: boolean;
}) {
  const api = useGameStoreApi();
  const currentDay = useGameSelector((s) => s.localState.currentDay);
  const { requestUndoTurn, confirmDialog, dialogOpen } = useUndoTurnConfirmation({
    restoreDay: currentDay - 1,
    onConfirm: onUndoCommittedTurn,
    pending,
  });

  const handleUndo = useCallback(() => {
    const state = api.getState();
    if (canUndoPendingMovesFromState(state)) {
      state.undoLastMove();
      return;
    }
    if (allowUndoFullTurn && canUndoCommittedTurnFromState(state)) {
      requestUndoTurn();
    }
  }, [allowUndoFullTurn, api, requestUndoTurn]);

  return { handleUndo, undoTurnDialog: confirmDialog, undoDialogOpen: dialogOpen };
}
